import { LSLastUrlTry } from 'modules/account';
import { applicationListStateName } from 'modules/application/list';
//Used to convert seconds to milliseconds. Open ID token expiration uses seconds since epoch time.
const MILLISECONDS_IN_SECOND = 1000;
export class AuthorizeServiceFactory {
    static $inject = ['$state', 'AuthenticationService', 'OidcService'];
    constructor($state, AuthenticationService, OidcService) {
        'ngInject';
        this.$state = $state;
        this.AuthenticationService = AuthenticationService;
        this.OidcService = OidcService;
    }
    async signInRedirect() {
        await this.OidcService.getInitializedPromise();
        return this.OidcService.UserManager.signinRedirectCallback();
    }
    async authenticate(user, externalObject = undefined) {
        const oidcData = JSON.parse(localStorage.getItem('oidc.azureB2CData'));
        const azureAdEnabled = !!oidcData && !!oidcData.isEnabled;
        this.AuthenticationService.auth = {
            ...(this.AuthenticationService.auth || {}),
            token: azureAdEnabled ? user.id_token : user.access_token,
            tokenType: user.token_type,
            expires: user.expires_at * MILLISECONDS_IN_SECOND,
            email: user.profile.email,
            extras: externalObject,
            redirectDefaultContract: true,
            objectId: user.profile.objectId,
        };
        const triedUrl = localStorage.getItem(LSLastUrlTry);
        if (triedUrl) {
            localStorage.setItem(LSLastUrlTry, '');
            // TODO: find a way to navigate to state instead of refresh page ($location.path() doesn't work initially)
            window.location.href = triedUrl;
        }
        else {
            this.$state.go(applicationListStateName);
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
AuthorizeServiceFactory.$inject = ['$state', 'AuthenticationService', 'OidcService'];
